import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
import ECommForm from "../ecommForm";
import ECommSession, { ECommStripePaymentProvider } from "../ecomm";

export default class MemberApplicationjs {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    async init(container$, products, provinces) {
        let that = this;
        this.container$ = container$;
        this.products = products;
        this.provinces = provinces;

        this.userRoleSelect$ = container$.find("#userRole");
        this.amountInput$ = container$.find("[name='amount']");
        this.form$ = container$.find("form");
        this.submitButton$ = this.form$.find("[type='submit']");

        this.userRoleSelect$.on("change", (ev) => {
            ev.preventDefault();
            this.amountInput$.val(this.getSelectedProduct().Amount / 100);
        });

        //EComm init:
        const pp = new ECommStripePaymentProvider({
            paymentProviderReferenceName: ECommSettings.StripePaymentProvider
        });

        this.session = new ECommSession();
        await this.session.initAsync({
            paymentProvider: pp
        });

        this.ecommFields = new ECommForm(container$);
        this.submitting = false;

        document.querySelectorAll("[data-tag=country]").forEach(ele => {
            ele.onchange = function () {
                var country = this.value;

                const provinceEle = document.getElementById(this.dataset.bind);
                provinceEle.value = "";

                country = country === "États-Unis" ? "United States" : country;

                if (country !== "Canada" && country !== "United States") {
                    provinceEle.hidden = true;
                    provinceEle.required = false;
                    return;
                } else {
                    provinceEle.hidden = false;
                    provinceEle.required = true;
                }

                const defaultOption = provinceEle.options[0].outerHTML;
                const filterProvince = [...that.provinces].filter(f => f.Country === country);

                const newProvinceDownlistData = filterProvince.map(province =>
                    `<option value="${province.Name}">${province.Name}</option>`);

                provinceEle.innerHTML = defaultOption + newProvinceDownlistData.join("");
            };

        });

        let otherSchool = document.querySelector("#otherSchool");
        document.querySelector("#school").onchange = function (e) {
            if (e.target.value == "Other" || e.target.value == "Autre") {
                otherSchool.hidden = false;
                otherSchool.required = true;
            }
            else {
                otherSchool.hidden = true;
                otherSchool.required = false;
            }
        };
    }

    getSelectedProduct() {
        const val = this.userRoleSelect$.val();
        return this.products[val];
    }

    async paymentSubmit() {
        const info = this.ecommFields.getCustomerInfo();

        const product = this.getSelectedProduct();

        const session = this.session;
        await session.getCustomer().updateInfo({
            info: info.Info
        });

        let customer = session.getCustomer();
        let order = await customer.newOrderAsync();

        await order.addItemAsync({
            variantID: product.VariantID,
            measureID: product.MeasureID,
            description: product.Title,
            quantity: 1
        });

        await order.checkoutAsync({
            shippingAddress: info.ShippingAddress,
            billingAddress: info.BillingAddress
        });
    }


    async postMemberApplication(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {
        e.preventDefault();
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedMemberMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'memberApplicationPage' });

        //Verify not already in system so we don't add application and charge customer:
        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'VerifyMemberApplicationPost', 'Member') === '422') {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("failedMemberMessage");
            that.utilsjs.hideById(successMessageId);
            button.disabled = false;
            return;
        }


        //Transaction:
        try {
            that.utilsjs.hideById("customFailedDuesMessage");
            this.ecommFields.hideError();
            await this.paymentSubmit();
        } catch (ex) {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("customFailedDuesMessage");
            that.utilsjs.hideById(successMessageId);
            button.disabled = false;
            return;
        }

        //UGC:
        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'MemberApplicationPost', 'Member') === '201') {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedMemberMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;
        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("failedMemberMessage");
            that.utilsjs.hideById(successMessageId);

        }
        button.disabled = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/memberApplication.js